import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { GetMyServers } from "../../Api/Panel/GetMyServers";

export default function Myserverspage() {
  const [myserversData, setMyServersData] = useState([]);
  const Get = async () => {
    const { data } = await GetMyServers();
    setMyServersData(data);
  };
  useEffect(() => {
    Get();
  }, []);
  return (
    <>
      <div className="flex col-span-4 xl:col-span-4 shadow-md border rounded-lg">
        <div className="py-8 px-5 w-full space-y-7">
          <h2 className="text-xl lg:text-2xl text-center pb-6 w-full black-color">
            Your Active Servers
          </h2>
          {myserversData?.map((el, i) => (
            <div
              key={i}
              className="overflow-hidden bg-white shadow-md sm:rounded-lg"
            >
              <div className="px-4 py-5 sm:px-6">
                <h3 className="text-lg font-medium leading-6 text-gray-900">
                  Server Information
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                  Server details and application.
                </p>
              </div>
              <div className="border-t border-gray-200">
                <dl>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Server Name
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {el.title}
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Server Status
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {el.Active === true ? "Active" : "Deactive"}
                    </dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      time interval
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {el.LeftDay} Days left
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Daily income / Server Price
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {el.DailyPrice} / {el.bigPrice}
                      {el.smallPrice}
                    </dd>
                  </div>

                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      About Server
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {el.About}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
